import { type ColorVariant, colorVariantOptions } from "./types";

export const stringToColorVariant = (str: string): ColorVariant => {
	let hash = 0;
	for (let i = 0; i < str.length; i++) {
		hash = str.charCodeAt(i) + ((hash << 5) - hash);
	}

	const randIndex = Math.abs(hash % (colorVariantOptions.length - 1));
	return colorVariantOptions[randIndex] as ColorVariant;
};
